// extracted by mini-css-extract-plugin
module.exports = {"cian-logo":"_84ff5fbbc9--cian-logo--ngkge"};